import { ChangeDetectorRef, Component, inject, OnInit, ViewChild } from '@angular/core';

// Bootstrap Import
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';

// third party
import { NgApexchartsModule } from 'ng-apexcharts';
import ApexCharts, { ApexOptions } from 'apexcharts';
import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexPlotOptions,
  ApexResponsive,
  ApexXAxis,
  ApexGrid,
  ApexStroke,
  ApexTooltip
} from 'ng-apexcharts';
import { SHARED_IMPORTS } from '../shared/shared.module';
import { LtHomeService } from './home.service';
import { ReportService } from '../reports/report.service';
import { Subscription, interval } from 'rxjs';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  responsive: ApexResponsive[];
  xaxis: ApexXAxis;
  colors: string[];
  grid: ApexGrid;
  tooltip: ApexTooltip;
  stroke: ApexStroke;
  // legend: ApexLegend;
};

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [...SHARED_IMPORTS, NgApexchartsModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {
  private cd = inject(ChangeDetectorRef);
  private service = inject(LtHomeService);
  private reportService = inject(ReportService);

  private refreshSubscription!: Subscription;
  refreshInterval: number = 30000; // Default refresh interval in milliseconds

  data: any = {
    averyProgressCount: 0,
    intouchProgressCount: 0,
    customerCount: 0,
    orderCount: 0
  };

  // private props
  @ViewChild('intouchChart') intouchChart!: ChartComponent;
  intouchChartOptions:any = {};
  intouchChartLoading = true;

  @ViewChild('averyChart') averyChart!: ChartComponent;
  averyChartOptions:any = {};
  averyChartLoading = true;
  monthChart: any;
  yearChart: any;
  colorChart = ['#673ab7'];

  
  // Constructor
  constructor() {
    this.intouchChartOptions = {
      series: [{
        name: 'Count',
        data: []
      }],
      dataLabels: {
        enabled: true,
      },
      chart: {
        type: 'bar',
        height: 480,
        toolbar: {
          show: true
        }
      },
      colors: [
        "#008FFB",
        "#FEB019",
        "#26a69a",
        "#546E7A",
        "#FF4560"
      ],
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: 'bottom',
              offsetX: -10,
              offsetY: 0
            }
          }
        }
      ],
      plotOptions: {
        bar: {
          // horizontal: false,
          distributed: true,
          columnWidth: '50%'
        }
      },
      xaxis: {
        type: 'category',
        categories: [],
        labels: {
          style: {
            colors: [
              "#008FFB",
              "#FEB019",
              "#26a69a",
              "#546E7A",
              "#FF4560",
            ],
            fontSize: "12px"
          }
        }
      },
      grid: {
        strokeDashArray: 4
      },
      tooltip: {
        theme: 'dark'
      }
    };
    this.averyChartOptions = {
      series: [{
        name: 'Count',
        data: []
      }],
      dataLabels: {
        enabled: true,
      },
      chart: {
        type: 'bar',
        height: 480,
        toolbar: {
          show: true
        }
      },
      colors: [
        "#FEB019",
        "#008FFB",
        "#26a69a",
        "#546E7A",
        "#FF4560",
      ],
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: 'bottom',
              offsetX: -10,
              offsetY: 0
            }
          }
        }
      ],
      plotOptions: {
        bar: {
          // horizontal: false,
          distributed: true,
          columnWidth: '50%'
        }
      },
      xaxis: {
        type: 'category',
        categories: [],
        labels: {
          style: {
            colors: [
              "#FEB019",
              "#008FFB",
              "#26a69a",
              "#546E7A",
              "#FF4560",
            ],
            fontSize: "12px"
          }
        }
      },
      grid: {
        strokeDashArray: 4
      },
      tooltip: {
        theme: 'dark'
      }
    };
  }

  // Life cycle events
  ngOnInit(): void {
    this.fetchData();
    // setTimeout(() => {
    //   this.monthChart = new ApexCharts(document.querySelector('#tab-chart-1'), this.monthOptions);
    //   this.monthChart.render();
    // }, 500);
    this.startAutoRefresh();
  }

  ngOnDestroy(): void {
    this.stopAutoRefresh();
  }

  startAutoRefresh(): void {
    this.refreshSubscription = interval(this.refreshInterval).subscribe(data => {
      this.fetchData();
    });
  }

  stopAutoRefresh(): void {
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
  }

  changeRefreshInterval(interval: number): void {
    this.refreshInterval = interval;
    this.stopAutoRefresh();
    this.startAutoRefresh();
  }

  fetchData() {
    this.getCounts();

    this.intouchChartLoading = true;
    this.averyChartLoading = true;
    this.getProgressStatusCount();
  }

  getCounts() {
    // this.dataLoadingFlag = true;
    // this.spinner.show();
    this.service.summaryCount().subscribe({
      next: (data:any) => {
        console.log("data from server ", data?.data);
        this.data = data?.data;
        // if(data?.data?.paginateLtCustomers) {
        //   this.records.push(...data.data.paginateLtCustomers.items);
        //   this.filters.lastKey = data.data.paginateLtCustomers.lastKey;
        // }
        // this.renderPage();

        // this.dataLoadingFlag = false;
        // this.spinner.hide();
        this.cd.detectChanges();
      },
      error: (err: any) => {
        // this.spinner.hide();
        console.log('data error: ', err);
        // this.cdref.detectChanges();
        // this.dataLoadingFlag = false;
      }
    })
  }

  getProgressStatusCount() {
    const intouchSeries = this.intouchChartOptions.series;
    if (intouchSeries && intouchSeries.length > 0) {
      const firstSeries = intouchSeries[0] as any; 
      firstSeries.data = [];
    }

    if (this.intouchChartOptions.xaxis) {
      this.intouchChartOptions.xaxis.categories = [];
    } else {
      this.intouchChartOptions.xaxis = { categories: [] };
    }

    // this.intouchChartOptions.series[0].data = [];
    // this.intouchChartOptions.xaxis.categories = [];

    const averySeries = this.averyChartOptions.series;
    if (averySeries && averySeries.length > 0) {
      const firstSeries = averySeries[0] as any; 
      firstSeries.data = [];
    }

    if (this.averyChartOptions.xaxis) {
      this.averyChartOptions.xaxis.categories = [];
    } else {
      this.averyChartOptions.xaxis = { categories: [] };
    }

    // this.averyChartOptions.series[0].data = [];
    // this.averyChartOptions.xaxis.categories = [];
    
    // this.dataLoadingFlag = true;
    // this.spinner.show();
    this.reportService.progressStatusCount().subscribe({
      next: (data:any) => {
        console.log("data from server ", data);
        this.renderInTouchChartData(data['InTouch']);
        this.renderAveryChartData(data['Avery']);
        // this.dataLoadingFlag = false;
        // this.spinner.hide();
        this.cd.detectChanges();
      },
      error: (err: any) => {
        // this.spinner.hide();
        console.log('data error: ', err);
        // this.cdref.detectChanges();
        // this.dataLoadingFlag = false;
      }
    })
  }

  renderInTouchChartData(data: any) {
    for (const key in data) {
      const value = data[key];
      // this.intouchChartOptions.series[0].data.push(value);
      const seriesItem: any = this.intouchChartOptions?.series?.[0];
      seriesItem.data.push(value);
      if (this.intouchChartOptions?.xaxis?.categories) {
        this.intouchChartOptions.xaxis.categories.push(key as any);
      }
      // this.intouchChartOptions?.xaxis?.categories?.push(key as any);
      // if (Object.prototype.hasOwnProperty.call(data, key)) {
      //   const value = data[key];
        
      // }
    }
    // this.intouchChart.render();
    console.log(this.intouchChartOptions)
    this.intouchChartLoading = false;
    
  }

  renderAveryChartData(data: any) {
    for (const key in data) {
      const value = data[key];
      // this.averyChartOptions?.series[0].data?.push(value);
      // this.averyChartOptions?.xaxis?.categories?.push(key as any);
      const seriesItem: any = this.averyChartOptions?.series?.[0];
      seriesItem.data.push(value);
      if (this.averyChartOptions?.xaxis?.categories) {
        this.averyChartOptions.xaxis.categories.push(key as any);
      }

      // if (Object.prototype.hasOwnProperty.call(data, key)) {
      //   const value = data[key];
        
      // }
    }
    // this.averyChart.render();
    console.log(this.averyChartOptions)
    this.averyChartLoading = false;
  }

  // public Method
  // onNavChange(changeEvent: NgbNavChangeEvent) {
  //   if (changeEvent.nextId === 1) {
  //     setTimeout(() => {
  //       this.monthChart = new ApexCharts(document.querySelector('#tab-chart-1'), this.monthOptions);
  //       this.monthChart.render();
  //     }, 200);
  //   }

  //   if (changeEvent.nextId === 2) {
  //     setTimeout(() => {
  //       this.yearChart = new ApexCharts(document.querySelector('#tab-chart-2'), this.yearOptions);
  //       this.yearChart.render();
  //     }, 200);
  //   }
  // }

  // ListGroup = [
  //   {
  //     name: 'Bajaj Finery',
  //     profit: '10% Profit',
  //     invest: '$1839.00',
  //     bgColor: 'bg-light-success',
  //     icon: 'ti ti-chevron-up',
  //     color: 'text-success'
  //   },
  //   {
  //     name: 'TTML',
  //     profit: '10% Loss',
  //     invest: '$100.00',
  //     bgColor: 'bg-light-danger',
  //     icon: 'ti ti-chevron-down',
  //     color: 'text-danger'
  //   },
  //   {
  //     name: 'Reliance',
  //     profit: '10% Profit',
  //     invest: '$200.00',
  //     bgColor: 'bg-light-success',
  //     icon: 'ti ti-chevron-up',
  //     color: 'text-success'
  //   },
  //   {
  //     name: 'ATGL',
  //     profit: '10% Loss',
  //     invest: '$189.00',
  //     bgColor: 'bg-light-danger',
  //     icon: 'ti ti-chevron-down',
  //     color: 'text-danger'
  //   },
  //   {
  //     name: 'Stolon',
  //     profit: '10% Profit',
  //     invest: '$210.00',
  //     bgColor: 'bg-light-success',
  //     icon: 'ti ti-chevron-up',
  //     color: 'text-success'
  //   }
  // ];

  // monthOptions = {
  //   chart: {
  //     type: 'line',
  //     height: 90,
  //     sparkline: {
  //       enabled: true
  //     }
  //   },
  //   dataLabels: {
  //     enabled: false
  //   },
  //   colors: ['#FFF'],
  //   stroke: {
  //     curve: 'smooth',
  //     width: 3
  //   },
  //   series: [
  //     {
  //       name: 'series1',
  //       data: [45, 66, 41, 89, 25, 44, 9, 54]
  //     }
  //   ],
  //   yaxis: {
  //     min: 5,
  //     max: 95
  //   },
  //   tooltip: {
  //     theme: 'dark',
  //     fixed: {
  //       enabled: false
  //     },
  //     x: {
  //       show: false
  //     },
  //     y: {
  //       title: {
  //         formatter: function (seriesName: any) {
  //           return 'Total Earning';
  //         }
  //       }
  //     },
  //     marker: {
  //       show: false
  //     }
  //   }
  // };

  // yearOptions = {
  //   chart: {
  //     type: 'line',
  //     height: 90,
  //     sparkline: {
  //       enabled: true
  //     }
  //   },
  //   dataLabels: {
  //     enabled: false
  //   },
  //   colors: ['#FFF'],
  //   stroke: {
  //     curve: 'smooth',
  //     width: 3
  //   },
  //   series: [
  //     {
  //       name: 'series1',
  //       data: [35, 44, 9, 54, 45, 66, 41, 69]
  //     }
  //   ],
  //   yaxis: {
  //     min: 5,
  //     max: 95
  //   },
  //   tooltip: {
  //     theme: 'dark',
  //     fixed: {
  //       enabled: false
  //     },
  //     x: {
  //       show: false
  //     },
  //     y: {
  //       title: {
  //         formatter: function (seriesName: any) {
  //           return 'Total Earning';
  //         }
  //       }
  //     },
  //     marker: {
  //       show: false
  //     }
  //   }
  // };
}
